import { gql } from "apollo-boost"

export const WIDGET_TEXT_CATEGORY_ESSENTIAL = gql`
    fragment WidgetTextCategoryEssential on WidgetTextCategory {
        id
        name
    }
`